// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"zHH8V","body":"t5Y-K","body-art":"U3N3a","rc-tabs-bar":"un6tn","rc-tabs-tab":"cMR81","rc-tabs-tab-active":"_8k1PS","content":"HVYfL","footer":"K-uQ8"};